import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import '../../../content/css/PortfolioAnalysis/FilterPanel.css';

export default class CollapsibleFilterBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        }
    }

    handleToggle = () => {
        this.setState({ open: !this.state.open });
    }

    render() {
        let icon = this.state.open ? '-' : '+';

        return (
            <div className="panel-box">
                <div className="top" onClick={this.handleToggle}>
                    <span>{this.props.title}</span>
                    <span>{icon}</span>
                </div>
                {this.state.open &&
                    <React.Fragment>
                        {this.props.children}
                    </React.Fragment>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/FilterPanel/CollapsibleFilterBox.js